import * as React from 'react';
import { Navigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { TextField, BaseTextFieldProps } from '@mui/material';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import '../../../hmilib/hmiglobal';

interface IBottomMenu {}

const BottomMenu = (props: IBottomMenu) => {
    const [refmenu, setRefmenu] = React.useState<string>();

    const [loadBottom, setloadBottom] = React.useState(true);

    let tick = function () {
        dateupdate();
    };

    let dateupdate = function () {
        let time = document.querySelector('.experion_bottom #time');
        let date = document.querySelector('.experion_bottom #date');
        if (time != null && date != null) {
            let curdate = new Date();
            time.innerHTML = curdate.toLocaleTimeString('en-GB');

            let month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
            date.innerHTML = [curdate.getDate(), '-', month[curdate.getMonth()], '-', curdate.getFullYear()].join('');
        }
    };

    React.useEffect(() => {
        let id = setInterval(() => {
            requestAnimationFrame(tick);
        }, 1000);
        return () => clearInterval(id);
    }, [loadBottom]);

    let KeySearch = function (e: any) {
        if (e.key == 'Enter') {
            window.SearchRun(e.target.value);
            e.target.value = '';
        }
    };

    let LoadPageName = function (name: string) {
        window.location.hash = '';

        let newref = '';
        if (name == 'pole') {
            newref = window.location.pathname.replace('experion', 'pole').replace('/hmi', '') + window.location.search;
        }

        setRefmenu(newref);
    };

    if (refmenu) return <Navigate to={refmenu} />;

    return (
        <header className="experion_bottom">
            <div id="messageActivAlarm" className="experion_bottom_line_one"></div>

            <div className="experion_bottom_line_two">
                <div className="experion_bottom_line_two_statusbar">
                    <div style={{ border: 'none', textAlign: 'left', fontWeight: 800, marginLeft: '10px' }}>
                        Honeywell
                    </div>
                    <div id="date">2-Jul-2020</div>
                    <div id="time">13:00:10</div>
                    <div
                        style={{ width: '9%', marginLeft: '1.5%', background: 'rgb(214, 211, 206)' }}
                        id="ActivAlarms"
                        className="activ"
                        href-attribute="#CallupPage&amp;Alarms"
                        onClick={() => {
                            window.OpenMnemo('jurnal');
                        }}>
                        Alarm
                    </div>
                    <div style={{ width: '9%', background: 'rgb(214, 211, 206)' }} className="activ" id="ActivSystem">
                        System
                    </div>
                    <div className="activ">&nbsp;</div>
                    <div className="activ">&nbsp;</div>
                    <div style={{ marginLeft: '1.5%' }} className="activ">
                        exp400srv
                    </div>
                    <div style={{ width: '9%' }} className="activ">
                        Stn1
                    </div>
                    <div style={{ width: '9%' }} className="activ"></div>
                </div>
            </div>
        </header>
    );
};

export default BottomMenu;
